import React, { useState } from 'react'
import { ShowSupportAssurancesContext } from './types'
import { DefaultSupportAssuranceInterface, SupportAssuranceInterface } from '../types'
import { FaChevronCircleLeft, FaPlus } from 'react-icons/fa'
import { useNavigate } from 'react-router'
import AddSupportAssModal from './AddSupportAssModal'
import DataSupportAssurance from './DataSupportAssurance'
import EditSupportAssModal from './EditSupportAssModal'
import SuccessMsg from '../../../Messages/SuccessMsg'
import DeleteSupportAssModal from './DeleteSupportAssModal'

const ShowSupportAssurance = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [showAddModal, setShowAddModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedSupportAss, setSelectedSupportAss] = useState<SupportAssuranceInterface>(DefaultSupportAssuranceInterface)

  const navigate = useNavigate()

  return (
    <ShowSupportAssurancesContext.Provider value={{
      showSuccessMsg, setShowSuccessMsg,
      showEditModal, setShowEditModal,
      showAddModal, setShowAddModal,
      showDeleteModal, setShowDeleteModal,
      selectedSupportAss, setSelectedSupportAss
    }}>
      {showSuccessMsg && <SuccessMsg modal={showSuccessMsg} toggle={() => setShowSuccessMsg(!showSuccessMsg)}/> }

      <div className="flex justify-start gap-2 mt-2">
        <FaChevronCircleLeft className='text-main mt-2' style={{ fontSize: "30px" }} onClick={() => { 
          navigate(`/assurances`)
        }} /> 
        <button className="p-2 rounded btn-main" onClick={() => setShowAddModal(!showAddModal)}>
          <FaPlus />
        </button>
      </div>
      <AddSupportAssModal modal={showAddModal} toggle={() => setShowAddModal(!showAddModal)}/>
      {showEditModal && 
        <EditSupportAssModal modal={showEditModal} toggle={() => setShowEditModal(!showEditModal)}/>
      }
      {showDeleteModal && 
        <DeleteSupportAssModal modal={showDeleteModal} toggle={() => setShowDeleteModal(!showDeleteModal)}/>
      }
      <DataSupportAssurance />
    </ShowSupportAssurancesContext.Provider>
  )
}

export default ShowSupportAssurance